module.exports = __webpack_public_path__ + "img/upload.96dc179d91a47912d8e795cc011910bf.96dc179d.png";